import { api } from '@/utils/Api/POS';
import { PostApiDirectWebstorePaymentsTransactionIdCreditBody } from '@/shared/api/models';

export class OnlinePaymentsApi {
    async refundPayment(transactionId: string, body: PostApiDirectWebstorePaymentsTransactionIdCreditBody) {
        return api.postApiDirectWebstorePaymentsTransactionIdCredit(transactionId, body);
    }
}

export const onlinePaymentsApi = new OnlinePaymentsApi();
